import _objectSpread from "/data/jenkins/workspaces/workspace/h5/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { mapGetters } from 'vuex';
import cache from '@/utils/cache';
import { parseUrl } from '@/utils/tools';
import { getQR, checkQR, axiosUrl } from '@/api/accountLogin';
var qrMixin = {
  data: function data() {
    return {
      isOnline: true,
      // 网络在线
      qrId: '',
      qrCodeExpired: false,
      // 二维码处在失效状态
      qrCodeInfo: 'error',
      qrCodeInvalid: false,
      qrInvalidMsg: '二维码已失效',
      errorIcon: 'refash_icon'
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['isQrLogin', 'network_online'])), {}, {
    // 登录后前往的系统地址
    service: function service() {
      var query = parseUrl(window.location.href);
      return query.service || '';
    },
    // 是否是云图梭的登录页面
    isYTS: function isYTS() {
      var decodeService = decodeURIComponent(this.service);
      return decodeService && decodeService.indexOf('://iwork') > 0 || decodeService.indexOf('://pwb-pre.longfor.com') > 0;
    }
  }),
  watch: {
    'network_online': function network_online(bool) {
      this.isOnline = bool;
      bool && this.isQrLogin && this.refreshQr();
    }
  },
  mounted: function mounted() {
    this.isOnline = window.navigator.onLine;
  },
  methods: _objectSpread(_objectSpread({}, require('@/assets/js/redirect.js').methods), {}, {
    /**
     * @func 获取/更新二维码
     */
    refreshQr: function refreshQr() {
      var _this = this;

      // 断网情况，取消执行
      if (!this.checkOnline()) return; // 当前不是二维码登录，直接返回

      if (!this.isQrLogin) return;
      this.qrCodeInvalid = false;

      var _parseUrl = parseUrl(window.location.href),
          appName = _parseUrl.appName;

      getQR({
        appIndexUrl: this.service,
        appName: appName || '',
        userAgent: navigator.userAgent
      }).then(function (res) {
        var code = res.code,
            data = res.data,
            message = res.message;

        if (code === '1') {
          _this.qrId = data.qrId;
          _this.qrCodeInfo = "longfor://login/scanCode?name=".concat(encodeURIComponent(data.appName), "&id=").concat(encodeURIComponent(data.qrId)); // 获取二维码成功后 开始轮询调用查询接口

          _this.qrCodeInvalid = false;
          _this.qrCodeExpired = false;

          _this.checkQrResult();
        } else {
          code === '3304' && _this.$message.error(message);
          throw new Error(message);
        }
      }).catch(function (err) {
        console.log('获取二维码失败:', err.message);

        _this.handleQrcodeError();
      });
    },

    /**
     * @func 验证用户画扫描二维码操作
     * @desc 轮循检查用户的扫描状态，若成功，前往目标服务地址
     */
    checkQrResult: function checkQrResult(config) {
      var _this2 = this;

      // 断网情况，取消执行
      if (!this.checkOnline()) return; // 先重置状态--防止帐号密码登录污染数据

      this.reset(); // 检查二维码扫描操作

      checkQR({
        qrId: this.qrId
      }).then(function (res) {
        var _ref = res || {},
            code = _ref.code,
            data = _ref.data,
            url = _ref.url;

        if (code === '1') {
          // 二维码扫描成功登录，跳转
          data.domains && (_this2.domains = decodeURIComponent(data.domains).split(','));
          _this2.wudomain = data.wudomain;
          _this2.url = url;

          _this2.redirect();

          _this2.$utils.loginZhuge('web-点击-登录页-登录成功', '扫码登录');
        } else if (code === '3011') {
          // 补充手机号
          _this2.bindPhone(data.userName);
        } else if (code === '3012' || code === '3013' || code === '3014') {
          // 账号探活
          _this2.oaProbe(data, code, url);
        } else if (code === '5204') {
          // 触发二次认证/双因子认证
          _this2.doubleVerify(code, data);
        } else if (code === '4224') {
          // 二维码已扫描，APP端取消登录
          _this2.handleQrcodeError('fail_wx', '已取消');

          _this2.$utils.loginZhuge('web-点击-登录页-登录失败');
        } else if (code === '4219') {
          // 二维码未扫描 app--尚未确认登录--继续轮询等待
          if (window.qrScanTimer) clearTimeout(window.qrScanTimer);
          window.qrScanTimer = setTimeout(function () {
            // 检查用户是否还在扫码页面
            _this2.isQrLogin && _this2.checkQrResult();
          }, 2000);
        } else {
          _this2.handleQrcodeError();

          config && config.autoRefreash && _this2.refreshQr();
        }
      }).catch(function (err) {
        console.log('二维码获取或扫描异常：', err.message);

        _this2.handleQrcodeError();

        _this2.$utils.loginZhuge('web-点击-登录页-登录失败');
      });
    },

    /**
     * @func 绑定手机号
     */
    bindPhone: function bindPhone(userNameEncode) {
      this.$utils.zhugeTrack('web-点击-登录页-绑定手机号', {
        '来源系统': 'IDM'
      });
      var search = window.location.search || '';
      this.$router.push({
        path: "/login/bindPhone".concat(search),
        query: {
          service: decodeURIComponent(this.service),
          userNameEnc: userNameEncode
        }
      });
    },

    /**
     * @func （非）强制探活
     * @desc 弹窗提示用户要探活，但可以点击暂不处理，继续登录操作
     * @param {String} code 3012-非强制探活, 3013-强制探活, 3014-等待探活待办确认
     */
    oaProbe: function oaProbe(data, code, url) {
      var type = code === '3012' ? 'warn' : code === '3013' ? 'force' : 'todoConfirm';
      this.$store.commit('init/SET_OA_PROBE_INFO', _objectSpread(_objectSpread({
        type: type
      }, data), {}, {
        url: url
      }));
      this.$store.commit('login/SET_LOGINTYPE', 'oaProbe');
    },

    /**
     * @func 二次认证/双因子认证
     * @param {Object} data 登录接口请求返回的数据
     * @param {String} message 触发原因
     * @param {String} loginType 登录类型 - passwordLogin、smsLogin
     * @desc [账号风控策略刷新]
     *       常用登录地区发生变更、
     *       登录设备更换超过3次、
     *       短时间内账号多设备或多IP登录、
     *       短时间内账号发生异地登录、
     *       短时间内账号异常登录次数过多、
     *       短时间内账号登录次数过多、
     *       当天密码连续错误超5次、
     *       超过3个月未登录等
     * @desc [data.twoFaAuthType]-二次认证类型
     *       0-短信认证：常用作外部账号和内部加白账号认证（默认）
     *       1-人脸认证：常用作内部无加白账号认证
     *       2-实人认证
     *       3-龙key（可配置）
     */
    doubleVerify: function doubleVerify(data, message, loginType) {
      var authData = data;
      authData.triggerReason = message; // 二次认证类型

      var twoFaAuthType = Number(data.twoFaAuthType) || 0; // NaN和0都返回0

      var authType = ['phone', 'qrCode', 'qrCode'][twoFaAuthType] || 'phone'; // 解决刷新页面后，二次认证类型丢失问题

      authData.authType = authType;
      cache.set('doubleUserInfo', authData);
      var search = window.location.search || ''; // 前往新版的二次认证页面

      this.$router.push({
        path: "doubleVerify".concat(search),
        query: {
          authType: authType
        }
      });
      this.$utils.zhugeTrack('web-二次认证-触发二次认证', {
        '认证类型': authType,
        '登录类型': loginType
      });
      authType === 'phone' && this.$utils.zhugeTrack('web-二次认证-触发短信认证');
      authType === 'qrCode' && this.$utils.zhugeTrack('web-二次认证-触发实人认证');
    },

    /**
     * @func 检查网络情况
     * @desc 断网：1）提示断网交互；2）若在二维码页面，禁用刷新按钮
     * @desc 在线，继续执行业务逻辑
     */
    checkOnline: function checkOnline() {
      !this.isOnline && this.handleQrcodeError('offlinewx', '当前网络不可用');
      return this.isOnline;
    },

    /**
     * @func 二维码扫描异常，显示错误提示
     */
    handleQrcodeError: function handleQrcodeError(icon, msg) {
      this.$message.close();
      this.qrCodeInvalid = true;
      this.qrCodeInfo = 'error';
      this.qrInvalidMsg = msg || '二维码已失效';
      this.errorIcon = icon || 'refash_icon';
    },

    /**
     * @func 短信登录/手机号登录通用
     * @func 对所有龙湖白名单域名种cookie，并前往服务页面地址
     * @param {Array} domains 表示异步种cookie的域名集合 -- 仅当龙湖是全栈https时，本方案才可行
     * @param {String} wuDomains
     * @param {String} url
     */
    buryCookiesAndToClient: function buryCookiesAndToClient(domains, wuDomain, url) {
      var _this3 = this;

      if (domains.length > 0) {
        domains.forEach(function (domain, i) {
          axiosUrl(domain).then(function (res) {
            // 所有请求发送完成，跨站cookie也就种完成。前往目标地址页面
            i === domains.length - 1 && _this3.handleRedirect(wuDomain, url);
          }).catch(function (err) {
            console.log('种cookie出现失败，当前domain：', domain, '\n发生错误：', err);
            i === domains.length - 1 && _this3.handleRedirect(wuDomain, url);
          });
        });
      } else {
        // 如果不是全栈https，走带有对应域名空白页方案，在空白页发起接口请求，种对应域名的cookie
        this.handleRedirect(wuDomain, url);
      }
    },

    /**
     * @func 前往对应域名下，发请求种cookie。前往该去的页面
     * @param {String} wuDomain 服务页面地址
     * @param {String} url 服务页面地址
     */
    handleRedirect: function handleRedirect(wuDomain, url) {
      if (wuDomain) {
        window.location.href = decodeURIComponent(wuDomain).split(',')[0].split('/cas/')[0] + "/blankpage/blank.html?jumpUrl=".concat(url, "&reqUrl=").concat(wuDomain);
      } else {
        window.location.href = this.$utils.uniteProtocol(url);
      }
    },

    /**
     * @function 重置页面状态
     */
    reset: function reset() {
      this.domains = [];
      this.wudomain = '';
      this.reqFlag = 0;
      this.url = '';
      this.userError = false; // 仅密码登录

      this.passwError = false; // 仅密码登录
    },

    /**
     * @func 立即注册
     */
    register: function register() {
      this.$utils.zhugeTrack('web-点击-登录页-立即注册', {
        '来源系统': 'IDM'
      });
      var url = window.location.search || '';
      this.$router.push("/login/registered".concat(url));
    },
    // 用户协议
    showProtocol: function showProtocol() {
      this.$store.commit('login/SET_PROTOCOL', true);
    },
    // 隐私政策
    showPrivacy: function showPrivacy() {
      this.$store.commit('login/SET_PRIVACY', true);
    },

    /**
     * @func 大前端APM初始化&诸葛初始化
     */
    initZhugeAndApm: function initZhugeAndApm(username) {
      try {
        window.zhuge.identify(username, {
          'OA帐号': username
        });
        window.zhuge.setSuperProperty({
          '登录用户': username,
          '服务系统': this.isYTS ? '云图梭' : 'SSO-Web'
        });
        window.MAIAAPM && window.MAIAAPM.setUid(username, true);
      } catch (err) {
        console.log('initZhugeAndApmError:', err);
      }
    }
  })
};
export default qrMixin;